import DashboardUpdateComponent from 'components/Dashboard/DashboardComponent/DashboardUpdateComponent';
import SnapshotComponent from 'components/Dashboard/DashboardComponent/SnapshotComponent';
import useLoadUnseenCounts from 'components/Dashboard/hooks/useLoadUnseenCounts';
import useAddMetaTags from 'components/Dashboard/utilities/addMetaTags';
import { useHeightContainer } from 'components/Dashboard/utilities/useHeightContainer';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';

interface UpdatePanelState {
  open: boolean;
  url: string | null;
}

const DailyBriefing = () => {
  const [updatePanelState, setUpdatePanelState] = useState<UpdatePanelState>({ open: false, url: null });
  const [transitionFinishes, setTransitionFinishes] = useState(false);
  const { open } = updatePanelState;
  const updateState = { updatePanelState, setUpdatePanelState };

  const [heightContainer, containerRef] = useHeightContainer();
  const navigate = useNavigate();
  const { date } = useParams<{ date?: string }>();
  const { addMetaTags } = useAddMetaTags();
  useLoadUnseenCounts();

  useEffect(() => {
    addMetaTags({ title: 'Inbox - Daily briefing - PolicyMogul' });
  }, [date]);

  useEffect(() => {
    if (open) {
      const timeoutId = setTimeout(() => setTransitionFinishes(true), 200);
      return () => clearTimeout(timeoutId);
    }
    setTransitionFinishes(false);
  }, [open]);

  const resetEventParameter = (props?: { search?: string }) => {
    const { search } = props ?? {};
    const searchParams = new URLSearchParams(search ?? window.location.search);
    searchParams.delete('in');
    navigate({ search: searchParams?.toString() }, { replace: true });
  };

  return (
    <div className='specific-top-padding-8 daily-briefing-page'>
      <div
        ref={containerRef}
        className='flex-centered flex-nowrap overflow-hidden position-relative'
        style={{ height: `${heightContainer}px` }}
      >
        <div className={`dashboard-panel-briefing ${open ? 'open pr-lg-3' : ''} h-100`}>
          <SnapshotComponent
            updateState={updateState}
            resetEventParameter={resetEventParameter}
            date={date}
            basePath='/monitor-inbox/daily-briefing'
          />
        </div>
        <div className={`dashboard-panel-update d-none d-lg-block h-100 ${open ? 'open' : ''}`}>
          <DashboardUpdateComponent
            updateState={updateState}
            transitionFinishes={transitionFinishes}
            resetEventParameter={resetEventParameter}
          />
        </div>
      </div>
    </div>
  );
};

export default DailyBriefing;
